import { render, staticRenderFns } from "./lni-isolated-workers-complaint-form.component.vue?vue&type=template&id=64618aee"
import script from "./lni-isolated-workers-complaint-form.component.vue?vue&type=script&lang=js"
export * from "./lni-isolated-workers-complaint-form.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports